<kendo-multiselect
  [class.dark-bg]="true"
  [data]="data"
  [filterable]="true"
  [valuePrimitive]="true"
  [value]="value"
  [textField]="'Value'"
  [valueField]="'Value'"
  (valueChange)="onChange($event)">
  <ng-template kendoMultiSelectTagTemplate let-dataItem>
    <div [class]="dataItem.Class"></div>
  </ng-template>
  <ng-template kendoMultiSelectItemTemplate let-dataItem>
    <div [class]="dataItem.Class"></div>
  </ng-template>
</kendo-multiselect>
